// React
import React from "react";

// Modules
import axios from "axios";
import Cookies from "js-cookie";

// Components
import { toast } from "sonner";

// Icons
import { Server } from "lucide-react";

const apiClient = axios.create({
  baseURL:import.meta.env.VITE_API_BASE_URL,
  withCredentials: true,
});

apiClient.interceptors.request.use(
  (config) => {
    const csrfToken = Cookies.get("csrftoken");
    if (csrfToken) {
      config.headers["X-CSRFToken"] = csrfToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        console.error(
          `User is not authenticated. Status Code: ${error.response.status}`
        );
        window.location.href = "/login";
      } else if (error.response.status === 403) {
        console.warn(
          `User lacks permission for this resource. Status Code: ${error.response.status}`
        );
      } else if (error.response.status === 429) {
        console.warn(
          `Request throttled. Too many requests. Status Code: ${error.response.status}`
        );
      } else if (error.response.status === 400) {
        console.error(
          `Invalid credentials. Status Code: ${error.response.status}`
        );
      } else if (error.response.status === 500) {
        console.error(
          `Internal server error (django). Status Code: ${error.response.status}`
        );
        toast.error("Internal server error", {
          description: "Server not responding. Please try again later.",
          icon: React.createElement(Server, {
            size: 16,
            strokeWidth: 2,
            "aria-hidden": true,
          }),
        });
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
